module.exports = __webpack_public_path__ + "img/pic1.91874662.png";